import {makeAutoObservable} from "mobx";
import {IPlatformProductVariant} from "../../../services/api/create-rma-service";


class PlatformVariantStore {
    private _model: IPlatformProductVariant;
    
    constructor(model: IPlatformProductVariant) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._model = model;
    }
    
    public get id(): number { return this._model.id; }
    public get title(): string { return this._model.title; }
    public get price(): number { return this._model.price; }
    public get quantity(): number { return this._model.inventory_quantity; }
    
}

export { PlatformVariantStore as default };
